module.exports = __webpack_public_path__ + "static/media/work-sumimoto.751e5a8e.jpg";